<template>
    <main class="max-width-container with-backdrop">
        <BackdropImage :src="tripImageUrl" />
        <h1 class="form-title">Add location</h1>
        <LocationForm
            v-if="!loading"
            ref="form"
            :back-link="`/trips/${tripId}`"
            :trip-id="tripId"
            :errors="errors"
            @submit-form="submitForm"
            @clear-error="clearError"
        />
    </main>
</template>

<script>
import LocationForm from "js/components/forms/LocationForm";
import BackdropImage from "js/components/common/BackdropImage";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import { useTripStore } from "js/stores/tripStore";
import { useUtilsStore } from "js/stores/utilsStore";
import { useUserStore } from "js/stores/userStore";
import { getGeoFromLatLong } from "js/lib/geocoding";

export default {
    name: "LocationAdd",
    components: {
        LocationForm,
        BackdropImage,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            loading: true,
            tripId: undefined,
            tripImageUrl: null,
            store: undefined,
            userStore: undefined,
            errors: {},
        };
    },
    mounted() {
        this.tripId = parseInt(this.$route.params.tripId);
        this.store = useTripStore();
        this.utilsStore = useUtilsStore();
        this.userStore = useUserStore();
        this.loading = false;
        this.store
            .fetch(`/api/trips/${this.tripId}`)
            .then((trip) => {
                this.tripImageUrl = trip.user_image_url;
            })
            .catch(() => {});
        if (this.$route.query.lat && this.$route.query.lon) {
            getGeoFromLatLong(this.$route.query.lat, this.$route.query.lon)
                .then((geo) => {
                    if (!geo.city) {
                        this.$refs.form.loadGeos(null);
                        return;
                    }
                    this.$refs.form.loadGeos(geo.city);
                })
                .catch(() => {
                    this.$refs.form.loadGeos(null);
                });
        }
    },
    methods: {
        submitForm(data) {
            this.store
                .create(
                    `/api/trips/${this.tripId}/locations`,
                    data,
                    !!data.user_image_file
                )
                .then(() => {
                    Promise.all([
                        this.store.refreshLocations(this.tripId),
                        this.userStore.refreshUser().catch(() => {}),
                    ]).then(() => {
                        this.$router.push(`/trips/${this.tripId}`);
                    });
                })
                .catch(this.handleResponseErrors);
            if (data.companions) {
                this.utilsStore.invalidate("companions");
            }
        },
    },
};
</script>
